'use es6';

import bootstrapWidget from '../../actions/bootstrapWidget';
import { initializeI18n } from '../../utils/initializeI18n';
import { fetchFeedbackSurvey } from '../../feedback-survey/feedbackSurveyEnabledSlice';
import { fetchVisitorThreads } from '../../threads/actions/ThreadActions';
import { getShouldFetchInitialVisitorThreads } from '../../threads/selectors/getShouldFetchInitialVisitorThreads';
import { navigateToInitialView } from '../../navigation/actions/navigateToInitialView';
import { setThreadsSuccess } from '../../threads/actions/setThreadsSuccess';
import { isInPreview } from '../../utils/isInPreview';
export const handleReceiveWidgetData = ({
  data
}) => (dispatch, getState) => {
  if (data) {
    return initializeI18n({
      data
    }).then(() => {
      var _data$spamProtectionM;
      const {
        message: {
          surveyId
        },
        sessionId
      } = data;
      if (surveyId !== null) {
        dispatch(fetchFeedbackSurvey(surveyId, sessionId));
      }
      dispatch(bootstrapWidget(data));
      const recaptchaToken = (_data$spamProtectionM = data.spamProtectionMetadata) === null || _data$spamProtectionM === void 0 ? void 0 : _data$spamProtectionM.token;
      if (recaptchaToken && !isInPreview()) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaToken}`;
        document.body.appendChild(script);
      }
      const shouldFetchVisitorThreads = getShouldFetchInitialVisitorThreads(getState());
      if (shouldFetchVisitorThreads) {
        dispatch(fetchVisitorThreads()).then(() => {
          dispatch(setThreadsSuccess());
          dispatch(navigateToInitialView());
        }).catch(err => {
          throw err;
        });
      } else {
        dispatch(setThreadsSuccess());
        dispatch(navigateToInitialView());
      }
    }, () => {
      dispatch(bootstrapWidget(data));
    });
  }
  return null;
};